
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feed",
      function () {
        return require("private-next-pages/feed/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feed"])
      });
    }
  